"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class NextLevelAccountHolder extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "NextLevelAccountHolder";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/next-level-ira/account-holders"
    );
  }
}

export default NextLevelAccountHolder;
